import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
    totalNew: {
        inspectingCompany: 0,
        shipOperator: 0,
        inspector: 0,
        inspectionFee: 0,
        sireReview: 0,
        nominationInspector: 0,
        nominationShipOperator: 0,
        inspectionProcess: 0,
        invoiceInspectingCompany: 0,
        invoiceShipOperator: 0,
        invoiceShipOperatorAdmin: 0,
        vessel: 0
    },
};

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        setDataTotalNewInspectingCompany: (state, action: PayloadAction<any>) => {
            state.totalNew.inspectingCompany = action.payload;
        },
        setDataTotalNewShipOperator: (state, action: PayloadAction<any>) => {
            state.totalNew.shipOperator = action.payload;
        },
        setDataTotalNewInspector: (state, action: PayloadAction<any>) => {
            state.totalNew.inspector = action.payload;
        },
        setDataTotalNewInspectionFee: (state, action: PayloadAction<any>) => {
            state.totalNew.inspectionFee = action.payload;
        },
        setDataTotalNewSireReview: (state, action: PayloadAction<any>) => {
            state.totalNew.sireReview = action.payload;
        },
        setDataTotalNewNominationInspector: (state, action: PayloadAction<any>) => {
            state.totalNew.nominationInspector = action.payload;
        },
        setDataTotalNewNominationShipOperator: (state, action: PayloadAction<any>) => {
            state.totalNew.nominationShipOperator = action.payload;
        },
        setDataTotalNewInspectionProcess: (state, action: PayloadAction<any>) => {
            state.totalNew.inspectionProcess = action.payload;
        },
        setDataTotalNewInvoiceInspectingCompany: (state, action: PayloadAction<any>) => {
            state.totalNew.invoiceInspectingCompany = action.payload;
        },
        setDataTotalNewInvoiceShipOperator: (state, action: PayloadAction<any>) => {
            state.totalNew.invoiceShipOperator = action.payload;
        },
        setDataTotalNewInvoiceShipOperatorAdmin: (state, action: PayloadAction<any>) => {
            state.totalNew.invoiceShipOperatorAdmin = action.payload;
        },
        setDataTotalNewVessel: (state, action: PayloadAction<any>) => {
            state.totalNew.vessel = action.payload;
        },
    },
});

export const {
    setDataTotalNewInspectingCompany,
    setDataTotalNewShipOperator,
    setDataTotalNewInspector,
    setDataTotalNewInspectionFee,
    setDataTotalNewSireReview,
    setDataTotalNewNominationInspector,
    setDataTotalNewNominationShipOperator,
    setDataTotalNewInspectionProcess,
    setDataTotalNewInvoiceInspectingCompany,
    setDataTotalNewInvoiceShipOperator,
    setDataTotalNewInvoiceShipOperatorAdmin,
    setDataTotalNewVessel
} = notificationSlice.actions;
export default notificationSlice.reducer;
